import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Legend, Tooltip, ResponsiveContainer } from 'recharts';
import ChartContainer from './ChartContainer';

export default function MetricRadarChart({
  data,
  companyLabel = 'Company',
  comparisonLabel = 'Average',
  title,
  loading,
  error,
  height = 400
}) {
  // Prepare data for radar chart
  // Expected format: [{ metric: 'Adoption Level', company: 85, average: 65 }, ...]
  const chartData = data || [];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="bg-bg-light dark:bg-bg-dark border border-border-light dark:border-border-dark rounded-lg shadow-lg p-3">
          <p className="font-semibold text-text-primary-light dark:text-text-primary mb-2">
            {data.metric}
          </p>
          {payload.map((entry, index) => (
            <p key={index} className="text-sm" style={{ color: entry.color }}>
              {entry.name}: {typeof entry.value === 'number' ? entry.value.toFixed(1) : entry.value}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <ChartContainer title={title} loading={loading} error={error} height={height}>
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart data={chartData}>
          <PolarGrid className="stroke-border-light dark:stroke-border-dark" />
          <PolarAngleAxis
            dataKey="metric"
            className="text-xs text-text-secondary-light dark:text-text-secondary" tick={{
              fontSize: 11,
              fontWeight: 500
            }}
          />
          <PolarRadiusAxis
            angle={90} // Move numbers away from the vertical line
            domain={[0, 100]}
            axisLine={false}
            tick={{
              fontSize: 10,
              fontWeight: 600,
              fill: "currentColor",
            }}
            // 2. Use 'fill-current' combined with your theme colors
            className="fill-text-primary-light dark:fill-text-secondary"
            dy={5}  // Fine-tunes vertical distance from axis
            dx={5}
          />
          <Radar
            name={companyLabel}
            dataKey="company"
            stroke="#64cc9c"
            fill="#64cc9c"
            fillOpacity={0.5}
          />
          <Radar
            name={comparisonLabel}
            dataKey="comparison"
            stroke="#8B5CF6"
            fill="#8B5CF6"
            fillOpacity={0.3}
          />
          <Legend
            wrapperStyle={{
              paddingTop: '20px'
            }}
          />
          <Tooltip content={<CustomTooltip />} />
        </RadarChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
}
